import { apiRequest } from '@/utils/api-request';
import type { FilestoreHistoryResponse } from '@/types/filestore';
import { filestoreErrorMessage } from './filestore-request';

export async function getFilestoreHistory(
  orgId: string,
  repo: string,
  filePath: string,
  options: { ref?: string; limit?: number } = {},
): Promise<FilestoreHistoryResponse> {
  const query = new URLSearchParams({ path: filePath });
  if (options.ref) query.set('ref', options.ref);
  if (options.limit) query.set('limit', String(options.limit));

  const response = await apiRequest<FilestoreHistoryResponse>({
    url: `/v1/orgs/${orgId}/repos/${encodeURIComponent(repo)}/history?${query.toString()}`,
    method: 'GET',
    target: 'filestore',
  });

  if (response.detail || !response.data) {
    throw new Error(
      filestoreErrorMessage(response, 'Failed to load file history'),
    );
  }
  return response.data;
}
